{
  "ep": {
    "errorSubcat": {
      "title": "There is an error",
      "desc": "Sorry, it seems there was an error loading this page."
    },
    "popupDetail": {
      "label": "Total Price"
    },
    "roaming": {
      "title": "Stay Connected Safely Abroad",
      "subtitle": "Stay connected wherever you are",
      "label": "Where is your destination?",
      "textButton": "Search Package",
      "placeholder": "Search destination country",
      "checkpack": "Search package"
    },
    "unregistered": {
      "title": "This number is not registered",
      "description": "Sorry, the number you entered is not registered. Please try again.",
      "buttonText": "Yes, Continue"
    },
    "form": {
      "titleText": "Enjoy the best package offers just for you",
      "buttonLabel": "Check",
      "simpatiLarge": "Enter your number to purchase a package or top up your credit",
      "haloLarge": "Enter your number to pay your bill or purchase a package"
    },
    "searchCounter": {
      "text": "Showing",
      "result": "results",
      "for": "for"
    }
  },
  "simpati": {
    "popup": {
      "titleHeader": "Complete Connection for All Activities",
      "title": "Enter SIMPATI Number",
      "description": "Check available packages or top up credit easily.",
      "placeholder": "Enter SIMPATI number",
      "buttonText": "Check"
    },
    "downloadCenter": {
      "title": "Manage Your Account and Get Exciting Promos Only on MyTelkomsel",
      "textButton": "Download MyTelkomsel"
    }
  },
  "halo": {
    "popup": {
      "titleHeader": "Make All Your Needs Easier",
      "title": "Enter Halo Number",
      "description": "Check available packages or top up credit easily.",
      "placeholder": "Enter HALO number",
      "buttonText": "Check"
    },
    "downloadCenter": {
      "title": "Manage Your Halo Account and Billing More Easily with MyTelkomsel",
      "textButton": "Download MyTelkomsel"
    },
    "otp": {
      "invalid": "Wrong OTP Code",
      "expired": "OTP code has expired, please resend the OTP",
      "maxAttempt": "Maximum attempts reached, please resend the OTP",
      "general": "An error occurred."
    },
    "bill": {
      "checkDescription": "Check your bill details here!",
      "checkNow": "Check Now",
      "dueDate": "Due date"
    }
  },
  "dls": {
    "downloadCenter": {
      "title": "Discover Exciting Entertainment Only on MyTelkomsel",
      "textButton": "Download MyTelkomsel"
    },
    "popup": {
      "titleHeader": "Enjoy a Wide Range of Apps with More Savings, More Choices, and Greater Convenience",
      "title": "Enter Your Telkomsel Number",
      "description": "Explore package offers available for you",
      "placeholder": "Enter your Telkomsel number",
      "buttonText": "Check"
    },
    "video": {
      "formTextLarge": "Enter Your Number and Get <span class='text-mustard'>Streaming Package</span> Offers", 
      "formTextSmall": "Explore <span class='text-mustard'>Streaming Package</span> Offers That Suit Your Needs"
    },
    "games": {
      "formTextLarge": "Enter Your Number and Get <span class='text-mustard'>Gaming Package</span> Offers",
      "formTextSmall": "Explore <span class='text-mustard'>Gaming Package</span> Offers That Suit Your Needs"
    },
    "music": {
      "formTextLarge": "Enter Your Number and Get <span class='text-mustard'>Music & Digital Package</span> Offers",
      "formTextSmall": "Explore Your Favorite <span class='text-mustard'>Music & Digital Package</span>  Offers"
    }
  },
  "digitalProduct": {
    "subscription": "Subscribe",
    "title": "Enter your phone number to view\nspecial package options and prices",
    "navbar": {
      "package": "Package",
      "phoneCredit": "Phone Credit",
      "billing": "Billing",
      "activationStatus": "Activation Schedule"
    },
    "button": {
      "findPackage": "Search",
      "findCredit": "Search",
      "viewAll": "View All"
    },
    "stepper": {
      "orderConfirmation": "Order Confirmation",
      "paymentMethod": "Payment Method",
      "orderStatus": "Order Status",
      "activationStatus": "Activation Schedule"
    },
    "error": {
      "postpaidNotEligible": "Destination number cannot be recharge.",
      "emptyMsisdn": "Destination number cannot be empty.",
      "unregistered": "Number you entered is missmatch or unregistered, please check number you entered.",
      "missLength": "Number cannot be more than 13 digits and less than 10.",
      "badRequest": "There is no package for number you entered.",
      "other": "An error occured in the system. Please try again later.",
      "pageNonTsel": "Fill in the number first to see package options and prices"
    },
    "filter": {
      "serviceCardTitle": "Service Card",
      "packageTitle": "Package Filters",
      "sortTitle": "Sort Packages",
      "destinationTitle": "Search Destination",
      "priceTitle": "Price",
      "quotaTitle": "Quota",
      "packageType": "Package Type {{name}}"
    },
    "input": {
      "destinationSearch": "Search Country"
    }
  },
  "placeholder": {
    "phone": "Input your phone number",
    "yourTelkomselNumber": "Enter your Telkomsel Number"
  },
  "input": {
    "msisdn": {
      "label": "Input your phone number",
      "example": "Example: ",
      "tselNumber": "Input Telkomsel number"
    },
    "errors": {
      "requiredPhoneTsel": "Please Enter Your Telkomsel Number",
      "requiredPhoneTselOrOrbitNumber": "Please Enter Your Telkomsel Prepaid or Orbit Number",
      "lessThanNineNumber": "Number less than 9. Please check again.",
      "required": "Number must be entered.",
      "requiredText": "{{text}} must be filled",
      "minlengthText": "{{text}} less than {{len}} digit, please input again",
      "maxlengthText": "{{text}} exceed the maximum limit of 12 digits",
      "requiredNumberPhone": "*Must fill in mobile number",
      "isNotMultipication": "Must be a multiple of 1000",
      "requiredEmail": "*Must fill email",
      "notTselNumber": "Not Telkomsel or by.U number. Please check back.",
      "notTselNumber2": "Not a Telkomsel number. Please check again",
      "notRegisteredNumber": "Number not registered. Please enter Telkomsel number",
      "internalServer": "An error occurred, please try again",
      "internalServer2": "An error occurred please try again later",
      "email": "Your email is invalid.",
      "notFound": "Data not found",
      "occurred": "An error occurred while loading data",
      "customerNotFound": "Customer not found",
      "requiredPhoneOrbit": "Please Enter Your Telkomsel Orbit Number",
      "invalidTelkomselNumber": "Enter a valid Telkomsel number (9–13 digits).",
      "invalidHaloNumber": "Enter a valid Halo number (9–13 digits).",
      "invalidSimpatiNumber": "Enter a valid SIMPATI number (9–13 digits).",
      "countryNotFound": "Sorry, country not available"
    }
  },
  "errors": {
    "network": {
      "basic": "Something went wrong please try again later."
    },
    "paymentNotAvailable": {
      "title": "Payment option with e-wallet is not available",
      "subtitle": "Please press retry to display the available payment methods.",
      "cta": "Retry"
    },
    "notfound": {
      "user": "User not found",
      "invoice": {
        "dashboard": "Invoice not found"
      },
      "package": "Package not available, Please reset Filter"
    },
    "internalError": {
      "reloadPage": "Please Reload this Page"
    },
    "login": {
      "invalid": {
        "credentials": "Something went wrong please try again later"
      }
    }
  },
  "button": {
    "viewAll": "View All",
    "loadMorePackages": "Load More Packages",
    "endOfListMessage": "Oops, you've reached the end of the package list.",
    "backToTop": "Back to Top",
    "resetFilter": "Reset Filter",
    "buy": "Buy",
    "accept": "Accept",
    "saveAsImage": "Save Code as Image",
    "signIn": "Sign In",
    "submit": "Submit",
    "save": "Save",
    "edit": "Edit",
    "connect": "Connect",
    "back": "Back",
    "yes": "Yes",
    "yup": "Yes",
    "cancel": "Cancel",
    "choose": "Choose",
    "continue": "Continue",
    "pay": "Pay",
    "sendOTP": "Send OTP",
    "change": "Change",
    "copy": "Copy",
    "package": "Package",
    "detail": "Detail",
    "hide": "Hide",
    "exchange": "Exchange",
    "look": "Look",
    "apply": "Apply",
    "viewDetails": "See details",
    "loadMore": "Load more",
    "loadMore2": "Load More",
    "reSend": "Resend",
    "editLabel": "Edit Label",
    "toPayment": "To payment",
    "remove": "Remove",
    "addNumber": "Add Number",
    "explore": "Explore Halo Digital Store",
    "backToHome": "Back to Home",
    "backToExplore": "Back to #JelajahDigital",
    "confirmPackageHallo": "Halo+ Package Confirmation",
    "tryAgain": "Try Again",
    "deleteFilter": "Clear Filter",
    "next": "Next",
    "uploadImage": "Upload Image",
    "download": "Download",
    "resend": "Resend",
    "close": "Close",
    "resubmit": "Resubmit",
    "delete": "Delete",
    "buyPackage": "Buy Package",
    "find": {
      "package": "Find Package",
      "bill": "Show Bill",
      "credit": "Find Credit"
    },
    "seePackage5G": "See 5G Packages",
    "backtoapp": "Back to app",
    "deleteNo": "No, Cancel",
    "deleteYes": "Yes, Delete",
    "use": "Use",
    "seeAll": "See All",
    "play": "Play",
    "manage": "Manage",
    "reset": "Reset",
    "done": "Done",
    "selectPayment": "Select Payment",
    "viewBilling": "View Billing",
    "rangeCheck": "Range Check",
    "skip": "Skip",
    "reload": "Reload",
    "saveAsDraft": "Save as Draft",
    "applyToStore": "Apply to Store",
    "existingNumber": "Use the current number",
    "newNumber": "Get a new number ",
    "proceedPayment": "Proceed to Payments",
    "orderAccept": "Order Received",
    "saveArchive": "Save & Archive",
    "savePublish": "Save & Publish",
    "verification": "Verification",
    "buyNow": "Buy Now",
    "toCheckout": "To Checkout",
    "sort": "Sort",
    "activated": "Activate",
    "subscribe": "Subscribe",
    "resetAlt": "Reset",
    "seeLocation": "View Shipping Methods",
    "outOfStock": "Stock not yet available"
  },
  "label": {
    "packageOptions": "Package Options",
    "msisdnEmpty": "Packages are not available, please enter your phone number!",
    "emptyPackageTitle": "No Matching Packages Yet",
    "emptyPackageDesc": "No packages available, please readjust your filter",
    "user": "user",
    "verified": "Verified",
    "change": "Change",
    "Laki-Laki": "Male",
    "Perempuan": "Female",
    "bill": "Bill",
    "credit": "Credit",
    "package": "Package",
    "signIn": "Sign In",
    "logIn": "Log In",
    "signOut": "Sign Out",
    "endsIn": "Ends In",
    "promoHasEnded": "Promo has ended",
    "tnc": "Terms and Conditions",
    "tnc2": "Terms and Conditions",
    "promoNotStarted": "The program will be started on",
    "validBilling": "Valid 1 Billing Cycle",
    "chooseProducts": "Choose Products",
    "categoryPackage": "Category Package",
    "detailProduct": "Product Detail Information",
    "price": "Price",
    "activePeriod": "Active Period",
    "lowest": "Lowest",
    "highest": "Highest",
    "backSoon": "We'll be right back!",
    "notTelkomselNumber": "Not Telkomsel number. Please check again",
    "backSoonDesc": "Sorry, this service is only available from 06:00 - 20:00 GMT+7, due to limitations for validating the National Registration number. Please try again at that time.",
    "status": {
      "available": "Available",
      "stillAvailable": "Still Available",
      "nearlyGone": "Nearly Gone",
      "finished": "Finished"
    },
    "notScheduleNotAvailable": "Schedule Not Available",
    "team": "tim",
    "errorOccured": "Server error occured",
    "productDescription": "Product Description",
    "seeDetails": "See Details",
    "saveWeb": "Telkomsel Halo App",
    "spesification": "Specification",
    "screen": "Screen",
    "rearCamera": "Rear Camera",
    "frontCamera": "Front Camera",
    "processor": "Processor",
    "baterai": "Battery",
    "howToPay": "How to Pay",
    "orderSummary": "Order Summary",
    "totalPayment": "Total Payment",
    "recommended": "Recommended",
    "month": "month",
    "days": "days",
    "hours": "hours",
    "minutes": "minutes",
    "seconds": "seconds",
    "promo5g": {
      "title": "Hyper 5G Package",
      "checkNumber": "Check 5G Coverage for Your Number",
      "checkNumberSub": "Please enter your Telkomsel number to get a 5G package, then check the 5G coverage",
      "subtitle": "Experience the ultra fast 5G network with a special package, get it at *363*56#.",
      "section": {
        "title": "Why 5G?",
        "section1": {
          "title": "20x Faster",
          "subtitle": "Faster data connection for smoother downloads and streaming."
        },
        "section2": {
          "title": "10x more responsive",
          "subtitle": "Very low latency makes for a more responsive connection."
        },
        "section3": {
          "title": "10x bigger",
          "subtitle": "Connect more devices without degrading network quality."
        }
      }
    },
    "check5g": {
      "title": "Check 5G Coverage",
      "subtitle": "Check 5G coverage in your location to enjoy 5G packages"
    },
    "noData": "No data show",
    "fillNumberFirst": "Fill in the number first to see the bill",
    "transactionProcessed": "Your transaction is being processed, please wait or close this page",
    "detail": "Details",
    "close": "Close",
    "failedToProcess": "Failed To Process",
    "shippingMethod": "Shipping Method",
    "receiptNumber": "Receipt Number",
    "orderStatus": "Order Status",
    "seeEvidence": "See Proof of Delivery",
    "allProducts": "All Products",
    "active": "Active ({{ len }})",
    "nonActive": "Non Active ({{ len }})",
    "totalPrice": "Total Price",
    "quota": "Quota",
    "limited": "Limited",
    "OutOfStock": "Out of stock",
    "backToInformation": "Back to Information",
    "description": "Key Feature Points",
    "voucherDetails": "Voucher Details",
    "minLengthTextarea": "Min. 20 Character",
    "sortLabel": "Sort",
    "emptyStock": "Out of stock",
    "from": "From",
    "shareTitle": "Share with others",
    "seeMore": "See more",
    "share": "Share",
    "stock": "Stock",
    "choose": "Choose",
    "selected": "Selected",
    "available": "Available",
    "alreadyUsed": "Already Used",
    "cost": "Cost",
    "period": "Period",
    "call188": "Call 188",
    "loading": "Loading...",
    "name": "Name",
    "filter": "Filter",
    "searchPlaceholder": "Type your search keyword here...",
    "searchHistory": "Search History",
    "popularSearch": "Popular Search",
    "packageRecommendation": "Package Recommendations",
    "chooseLanguage": "Choose Language",
    "bahasaIndonesia": "Indonesian",
    "voucherCode": "Voucher Code",
    "voucher": "Voucher",
    "voucherCodeCopied": "Voucher Code Copied",
    "selectVariant": "Select Variant",
    "selectQuantity": "Select Quantity",
    "useVoucher": "Use Voucher",
    "allPackages": "All Packages",
    "productUnavailable": "Product currently unavailable",
    "productUnavailableDesc": "Don't worry, products will be available again, please check back later!",
    "noMoreProducts": "No more products available.",
    "seeCreditOptions": "See credit options",
    "seePackageOptions": "See package options",
    "loadLessCredit": "Load less credit",
    "loadMoreCredit": "Load more credit",
    "priceValidation": "Maximum price must be greater than or equal to minimum price",
    "creditNominalOptions": "Credit Nominal Options",
    "sold": "Sold"
  },
  "transitionNumber": {
    "description": "Would you like to continue and view packages available for this number?",
    "registeredHalo": "This number is registered as a Halo customer",
    "registeredOrbit": "This number is registered as an Orbit customer",
    "registeredSimpati": "This number is registered as a SIMPATI customer"
  },
  "billPopup": {
    "title": "You Have a Bill Ready to Pay",
    "description": "Check the details and pay on time to keep your service active",
    "primaryButton": "Pay Now",
    "secondaryButton": "Later",
    "billInfo": {
      "status": "Unpaid",
      "title": "Total Bill"
    }
  },
  "productDetail": {
    "tabs": {
      "detail": "Detail",
      "description": "Description",
      "tnc": "T&C"
    },
    "tabsAriaLabel": "Product Detail",
    "closeAriaLabel": "Close",
    "detail": {
      "empty": "No details available.",
      "dataDescription": "Internet quota for all networks."
    },
    "description": {
      "title": "Package Description"
    },
    "tnc": {
      "title": "Terms & Conditions"
    },
    "footer": {
      "totalLabel": "Total Payment",
      "currencySymbol": "Rp"
    }
  },
  "verification_otp": {
    "close": "Close",
    "title": "OTP Verification",
    "description": "Enter the secret code sent via SMS to",
    "retry": "Try Again",
    "verify": "Verify",
    "expires": "Valid until",
    "resend": "Resend OTP Code",
    "waiting": "Please wait to resend OTP.",
    "errors": {
      "invalid": "Invalid OTP Code",
      "expired": "OTP code expired, please resend OTP",
      "max_attempt": "Attempts exceeded limit, please resend OTP",
      "general": "An error occurred."
    }
  },
  "nobillPopup": {
    "title": "No Bill",
    "description": "Your bill has been paid or there is no bill for this number",
    "primaryButton": "Back"
  },
  "toast": {
    "general": "Login attempt unsuccessful. Please try again."
  }
}
